import { render, staticRenderFns } from "./ExitIntentPopup.vue?vue&type=template&id=857a4644&scoped=true"
import script from "./ExitIntentPopup.vue?vue&type=script&lang=js"
export * from "./ExitIntentPopup.vue?vue&type=script&lang=js"
import style0 from "./ExitIntentPopup.vue?vue&type=style&index=0&id=857a4644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857a4644",
  null
  
)

export default component.exports